import cl from "clsx";
import { LoaderCircle } from "lucide-react";

interface LoadingSpinnerProps {
    size?: "sm" | "md" | "lg";
    className?: string;
}

export default function LoadingSpinner({ size = "sm", className }: LoadingSpinnerProps) {
    return (
        <LoaderCircle
            className={cl(
                "animate-spin motion-reduce:animate-[spin_1.5s_linear_infinite]",
                {
                    "h-4 w-4": size === "sm",
                    "h-8 w-8": size === "md",
                    "h-12 w-12": size === "lg",
                },
                className
            )}
        />
    );
}
